import "./index.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import AppShell from "../../components/appShell";
import PlayerDetails from "../../components/playerDetails";
import RtmPanel from "../../components/rtmPanel";
import Modal from "../../components/modal";
import BiddingPrice from "../../components/biddingPrice";
import { Avatar, Pill, money, shortName } from "../../components/atoms";
import { incrementsForBid } from "../../config/auctionRules";
import { useAuctionRules } from "../../config/useAuctionMode";
import {
  activeBidding,
  bid,
  boughtPlayers,
  getActiveSession,
  getProfile,
  purseremaining as getPurse,
  selectactiveBidding,
  selectActiveSession,
  selectBidderProfile,
  selectFilteredPlayers,
  selectpurseremaining,
  blockStatus,
  selectBlockStatus,
  lastYearPlayer,
  selectLastYearPlayersData,
  rtm,
  selectLoginStatus,
} from "../../store/features/bidderSlice";
import { useSocketRoom } from "../../hooks/useSocketRoom";

const BiddingPage = ({ socket }) => {
  let [counter, setCounter] = useState(1);
  let [RTM, setRTM] = useState(false);
  let [bidSetting, setBidSetting] = useState([5, 10]);
  let [bidAtBase, setBidAtBase] = useState(false);
  let [content, setContent] = useState("");
  let [blockBidding, setBlockBidding] = useState(false);
  let [stopBidding, setStopBidding] = useState(false);
  let [disabled, setDisabled] = useState(false);
  let [showLoading, setShowLoading] = useState(false);
  let [activeBid, setActiveBid] = useState();
  let LoginStatus = useSelector(selectLoginStatus);
  let profile = useSelector(selectBidderProfile);
  let session = useSelector(selectActiveSession);
  let activePlayer = useSelector(selectactiveBidding);
  let purseremaining = useSelector(selectpurseremaining);
  let lastYearData = useSelector(selectLastYearPlayersData);
  let filteredPlayerData = useSelector(selectFilteredPlayers);
  let blockActiveStatus = useSelector(selectBlockStatus);
  let auctionRules = useAuctionRules();
  let dispatch = useDispatch();

  // Rejoins on every reconnect, so a dropped socket recovers on its own.
  useSocketRoom(socket, { role: "bidder", id: profile?._id, sessionId: session?.sessionId });


  useEffect(() => {
    dispatch(getProfile());
    dispatch(activeBidding());
    dispatch(getActiveSession());
    dispatch(getPurse());
    dispatch(lastYearPlayer());
    dispatch(boughtPlayers());
    dispatch(blockStatus());
  }, [counter]);

  useEffect(() => {
    if (lastYearData?.LastYearPlayer?.[0]) {
      let match = lastYearData?.LastYearPlayer?.find(
        (p) => activePlayer?._id?.toString() === p
      );

      if (match) {
        setRTM(true);
      } else {
        setRTM(false);
      }
    } else {
      setRTM(false);
    }
  }, [activePlayer, lastYearData]);

  useEffect(() => {
    setBlockBidding(profile?.bidBlockStatus);
    setStopBidding(session?.biddingStopped);
  }, [profile?.bidBlockStatus, session?.biddingStopped]);

  useEffect(() => {
    if (activePlayer?.name) {
      if (activePlayer?.currentBid > 0) {
        setBidAtBase(false);
        // Which raises are on offer comes from the rules the auction started
        // under, so a women's auction stays on 5/10/20 while a men's steps up
        // past a crore - and either can be overridden by the admin.
        let increments = incrementsForBid(auctionRules, activePlayer.currentBid);
        setBidSetting(increments);
        if (!Boolean(activeBid)) {
          setActiveBid(increments[0]);
        }
      } else {
        let base = activePlayer?.basePrice;
        setBidAtBase(true);
        setBidSetting([base]);
      }
    } else {
      setBidSetting([]);
    }
  }, [activePlayer?.currentBid, activePlayer, auctionRules]);

  useEffect(() => {
    socket.on("block-started", (playerType) => {
      setContent(playerType?.toUpperCase() + " BLOCK STARTED!");
      setShowLoading(true);
      setCounter((a) => a + 1);
      setTimeout(() => {
        setShowLoading(false);
      }, 2500);
    });

    // setContent(
    //   <>
    //     <div style={{ fontSize: "1.7rem", textTransform: "uppercase" }}>
    //       Bidding Stopped
    //     </div>
    //     <RoundButton
    //       className="round-btn-rtm"
    //       style={{
    //         "&:hover": {
    //           color: "#fff",
    //         },
    //         marginTop: "1rem",
    //         padding: ".5rem 1.2rem",
    //         fontSize: "1rem",
    //         minWidth: "fit-content",
    //         textTransform: "uppercase",
    //       }}
    //     >
    //       use RTM
    //     </RoundButton>
    //   </>
    // );
    // setShowLoading(true);

    socket.on("block-paused", () => {
      setContent(
        <>
          <span>Bidding Stopped</span>
        </>
      );
      setShowLoading(true);
      setCounter((a) => a + 1);
      setTimeout(() => {
        setShowLoading(false);
      }, 2500);
    });

    socket.on("block-finished", (playerType) => {
      setShowLoading(true);
      //  // console.log(playerType);
      setContent(playerType?.toUpperCase() + " BLOCK FINISHED!");
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    });

    socket.on("set-bid-reset", () => {
      setContent(
        <>
          {/* <img src={depressed} style={{ height: "13rem" }} /> */}
          <span
            style={{
              color: "inhe",
              fontSize: "2rem",
            }}
          >
            {" "}
            UPDATING DATA...
          </span>
        </>
      );

      setShowLoading(true);

      // setContent();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      setCounter((a) => a + 1);
    });

    socket.on("bid-updated", (playerData) => {
      //  // console.log(playerData);
      setBlockBidding(false);
      setBidAtBase(false);
      setActiveBid(0);
      setCounter((a) => a + 1);

      if (playerData?.data) {
        setShowLoading(true);
        setContent(
          <div className="call">
            <span className="call-note success">Next player</span>
            <span className="call-team">{playerData?.data?.name}</span>
          </div>
        );
        setTimeout(() => {
          setShowLoading(false);
          // window.location.reload();
        }, 2000);
      }
    });

    socket.on("rtm-stage-changed", () => {
      setCounter((a) => a + 1);
    });

    socket.on("rtm-updated", (playerData) => {
      //  // console.log(playerData);
      setBlockBidding(true);
      dispatch(getActiveSession());

      if (playerData?.data) {
        setShowLoading(true);
        setContent(
          <div className="call">
            <span className="call-note success">Next player</span>
            <span className="call-team">{playerData?.data?.name}</span>
          </div>
        );
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
      setCounter((a) => a + 1);
    });

    socket.on("set-player-unsold", () => {
      setContent(
        <div className="call">
          <span className="call-verdict danger">Unsold</span>
        </div>
      );
      setShowLoading(true);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
      setCounter((a) => a + 1);
    });

    console.log(profile?.Franchise?._id);
    socket.on("set-player-sold", (player) => {
      setCounter((a) => a + 1);
      dispatch(activeBidding());
      setShowLoading(true);
      setContent(
        <div className="call">
          <span
            className={`call-verdict ${
              player?.currentBid === profile?.activeBidding?.lastBid &&
              player?.lastBidBy?.Franchise === profile?.Franchise?._id
                ? "success"
                : "danger"
            }`}
          >
            Sold
          </span>
          <span className="call-team">{player?.lastBidBy?.team}</span>
        </div>
      );
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    });

    socket.on("stop-bid", () => {
      //  // console.log("svibi");
      setShowLoading(true);
      setContent(
        <div className="call">
          <span
            className={`call-note ${
              activePlayer?.currentBid === profile?.activeBidding?.lastBid
                ? "success"
                : "danger"
            }`}
          >
            Bidding stopped
          </span>
        </div>
      );
      setCounter((a) => a + 1);
      dispatch(getActiveSession());

      setBlockBidding(true);
      setStopBidding(true);
      setCounter((a) => a + 1);
      setTimeout(() => {
        setShowLoading(false);
        // window.location.reload();
      }, 2000);
    });

    socket.on("resume-bid", () => {
      setShowLoading(true);
      setContent(
        <div className="call">
          <span className="call-note success">Bidding resumed</span>
        </div>
      );
      dispatch(getActiveSession());
      setBlockBidding(false);

      setBlockBidding(false);
      setStopBidding(false);
      setCounter((a) => a + 1);
      setTimeout(() => {
        setShowLoading(false);
        // window.location.reload();
      }, 2000);
    });
  }, [session?.sessionId]);

  const onBidClick = async () => {
    if (session?.sessionId) {
      socket.emit("check-bid-status", session?.sessionId);
      setBlockBidding(true);
      let bidValue = activeBid
        ? activePlayer?.currentBid + activeBid
        : activePlayer?.basePrice;

      let bidIncreaseValue = activeBid ? activeBid : activePlayer?.basePrice;

      // For A loading time wait
      setDisabled(true);
      setContent(
        <div className="call">
          <span className="call-note">Bid queued</span>
          <span className="call-team">{shortName(activePlayer?.name)}</span>
          <span className="call-note success">+{money(bidIncreaseValue)}</span>
        </div>
      );
      // For A loading time wait

      if (bidValue < purseremaining?.value) {
        let res = await dispatch(
          bid({
            base: bidAtBase,
            value: Number(activeBid),
          })
        );
        if (res?.payload?.statusCode === 200) {
          console.log(res?.payload?.data?.currentBid);
          let latestCurrentBid = res?.payload?.data?.currentBid;
          setDisabled(true);

          setContent(
            <div className="call">
              <span className="call-note">Bid posted at</span>
              <span className="call-team">{shortName(activePlayer?.name)}</span>
              <span className="call-note success">
                {money(latestCurrentBid)}
              </span>
            </div>
          );
          let res2 = await dispatch(activeBidding());
          if (res2?.payload?.statusCode === 200) {
            socket.emit("increase-bid", session?.sessionId);
          }
          setTimeout(() => {
            setDisabled(false);
          }, 5000);
        } else if (res?.payload?.statusCode === 304) {
          setDisabled(true);

          setContent(
            <div className="call">
              <span className="call-note">Bid not possible</span>
              <span className="call-note danger">{res?.payload?.msg}</span>
            </div>
          );
          setTimeout(() => {
            setDisabled(false);
          }, 2000);
          await dispatch(getProfile());
        }
      } else {
        setContent(
          <div className="call">
            <span className="call-note">Bid not possible</span>
            <span className="call-verdict danger">No funds</span>
            <span className="call-team">Hatt bikhari</span>
          </div>
        );
        setDisabled(true);
        setTimeout(() => {
          setDisabled(false);
        }, 2000);
      }
      setCounter((a) => a + 1);
    }
  };

  const onRTMClick = async () => {
    if (session?.sessionId) {
      socket.emit("check-rtm-status", session?.sessionId);
      let bidValue = activePlayer?.currentBid;

      if (bidValue < purseremaining?.value) {
        setContent(
          <div className="call">
            <span className="call-note">Bid posted</span>
            <span className="call-team">{shortName(activePlayer?.name)}</span>
            <span className="call-note success">{money(bidValue)}</span>
          </div>
        );
        setDisabled(true);
        let res = await dispatch(
          rtm({
            value: Number(activeBid),
          })
        );
        if (res?.payload?.statusCode === 200) {
          let res2 = await dispatch(activeBidding());
          if (res2?.payload?.statusCode === 200) {
            socket.emit("apply-rtm", session?.sessionId);
          }
        }

        setTimeout(() => {
          setDisabled(false);
        }, 1000);
      } else {
        setContent(
          <div className="call">
            <span className="call-note">Bid not possible</span>
            <span className="call-verdict danger">No funds</span>
            <span className="call-team">Hatt bikhari</span>
          </div>
        );
        setDisabled(true);
        setTimeout(() => {
          setDisabled(false);
        }, 2000);
      }
      setCounter((a) => a + 1);
    }
  };


  if (LoginStatus === "waiting") {
    return (
      <div className="bid-loading">
        <CircularProgress sx={{ color: "#0040a8" }} />
      </div>
    );
  }

  if (LoginStatus === "failed") {
    return (
      <AppShell role="public">
        <h1 className="au-heading">Not signed in</h1>
        <p className="au-subheading">
          <Link to="/bidder/login">Sign in as a bidder</Link> to join the
          auction.
        </p>
        <Navigate to="/bidder/login" replace />
      </AppShell>
    );
  }

  const live =
    blockActiveStatus === "started" && session?.sessionId && session?.active;

  // I already hold the highest bid on this player.
  const mine =
    activePlayer?.currentBid === profile?.activeBidding?.lastBid &&
    activePlayer._id === profile?.activeBidding?.player &&
    activePlayer?.lastBidBy?.franchise?.toString() ===
      profile?.Franchise?._id?.toString();

  // Where the mode caps a count, show it against the cap. A cap of 0 means the
  // rules do not limit that group, so the bare number is shown instead.
  const against = (count, cap) => (cap ? `${count}/${cap}` : `${count}`);

  const squad = [
    [
      "Overseas",
      against(filteredPlayerData?.Overseas?.length || 0, auctionRules.overseas.max),
    ],
    [
      "Indians",
      against(filteredPlayerData?.Indians?.length || 0, auctionRules.indians.max),
    ],
    ["Uncapped", filteredPlayerData?.Uncapped?.length || 0],
    ["Batters", filteredPlayerData?.Batter?.length || 0],
    ["Bowlers", filteredPlayerData?.Bowler?.length || 0],
    ["Wicketkeepers", filteredPlayerData?.Wicketkeeper?.length || 0],
    ["All rounders", filteredPlayerData?.["All Rounder"]?.length || 0],
  ];

  // The round lives on the player, so every screen agrees on the stage without
  // having to track it locally.
  const rtmStage = activePlayer?.rtm?.stage;
  const rtmOpen = Boolean(rtmStage) && rtmStage !== "none" && rtmStage !== "settled";

  const canBid = Boolean(activeBid) && activePlayer?._id && !blockBidding;

  return (
    <AppShell role="bidder">
      <Modal show={showLoading || disabled} content={content} />

      <header className="bid-head">
        <div>
          <h1 className="au-heading">
            {profile?.Franchise?.name || profile?.name || "Bidding"}
          </h1>
          <p className="au-subheading">
            {live
              ? "Bidding is open. Pick a raise and bid."
              : "Waiting for the curator to start a category."}
          </p>
        </div>

        <div className="bid-head-stats">
          <div className="bid-stat">
            <span className="au-label">Purse left</span>
            <span className="bid-stat-value">
              {money(purseremaining?.value)}
            </span>
          </div>
          <div className="bid-stat">
            <span className="au-label">Right to match</span>
            <span className="bid-stat-value">
              {profile?.Franchise?.rtm ?? 0}
            </span>
          </div>
        </div>
      </header>

      <div className="bid-layout">
        <section className="bid-main">
          {live ? (
            <>
              <div className="bid-now">
                <PlayerDetails player={activePlayer} />

                <div className="bid-figure">
                  <span className="au-label">Current bid</span>
                  <span className="bid-figure-value">
                    {money(activePlayer?.currentBid)}
                  </span>
                  <span className="bid-figure-by">
                    {activePlayer?.lastBidBy?.team ? (
                      <>
                        <Avatar
                          name={activePlayer.lastBidBy.team}
                          src={activePlayer?.lastBidBy?.franchise?.image}
                          size={24}
                          logo
                        />
                        {activePlayer.lastBidBy.team}
                      </>
                    ) : (
                      "No bids yet"
                    )}
                  </span>
                </div>
              </div>

              {mine ? (
                <div className="bid-placed">
                  <Pill tone="success solid">Your bid stands</Pill>
                  <p className="bid-placed-note">
                    {stopBidding
                      ? "Bidding is closed. Waiting on the auctioneer."
                      : "Waiting for another team to raise."}
                  </p>
                </div>
              ) : rtmOpen ? (
                <div className="bid-controls">
                  <RtmPanel
                    player={activePlayer}
                    franchise={profile?.Franchise}
                    purse={purseremaining?.value}
                    onActed={(result) => {
                      socket.emit("rtm-stage", {
                        sessionId: session?.sessionId,
                        stage: result?.stage,
                      });
                      // A settled round closes the lot on the server, so the
                      // room needs the same "sold" signal the curator sends.
                      if (result?.sold) {
                        socket.emit("player-sold", {
                          ...activePlayer,
                          currentBid: result.finalBid,
                          sessionId: session?.sessionId,
                        });
                      }
                      setCounter((a) => a + 1);
                    }}
                  />
                </div>
              ) : stopBidding ? (
                /* Bidding is shut: the server refuses a raise, so offering the
                   buttons only invites a click that cannot work. */
                <div className="bid-placed">
                  <Pill tone="quiet">Bidding closed</Pill>
                  <p className="bid-placed-note">
                    Waiting on the auctioneer to close the lot.
                  </p>
                </div>
              ) : (
                <div className="bid-controls">
                  <span className="au-label">
                    {bidAtBase ? "Open at base price" : "Raise by"}
                  </span>

                  {bidSetting?.length ? (
                    <div className="bid-steps">
                      {bidSetting.map((item) => (
                        <BiddingPrice
                          key={item}
                          price={item}
                          selected={activeBid === item}
                          onClick={() => {
                            if (!activePlayer?.name) return setActiveBid(false);
                            if (activePlayer.currentBid) setActiveBid(item);
                            else setActiveBid(activePlayer?.basePrice);
                          }}
                        />
                      ))}
                    </div>
                  ) : (
                    <p className="bid-rtm-note">Waiting for a player…</p>
                  )}

                  <button
                    type="button"
                    className="au-btn primary block"
                    disabled={!canBid}
                    onClick={onBidClick}
                  >
                    {activeBid
                      ? `Bid ${money(
                          activePlayer?.currentBid
                            ? activePlayer.currentBid + activeBid
                            : activePlayer?.basePrice
                        )}`
                      : "Bid"}
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="bid-idle">
              <Pill tone="quiet">Bidding closed</Pill>
              <p className="bid-idle-note">
                Nothing is on the block right now.
              </p>
            </div>
          )}
        </section>

        <aside className="bid-side">
          <section className="au-card">
            <span className="au-label">Squad so far</span>
            <ul className="bid-squad">
              {squad.map(([label, count]) => (
                <li key={label} className="bid-squad-row">
                  <span className="bid-squad-label">{label}</span>
                  <span className="bid-squad-count">{count}</span>
                </li>
              ))}
            </ul>
          </section>
        </aside>
      </div>
    </AppShell>
  );
};

export default BiddingPage;
